import landingPageHeaderImage from '../../../../ui/assets/missionHeaderIllustration.svg';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { PageHeaderWithImage } from '@juvare/common-web-ui/PageHeader';
import { Box } from '@mui/material';
import React from 'react';
import { MissionPlaceholders } from './MissionsPlaceholders';
export const MissionListHeader = (props) => {
    const { appTitle, missionsCount, volunteerHours } = props;
    const { t } = useMissionsTranslation();
    return (React.createElement(PageHeaderWithImage, { gradient: 'orange-light', title: t('missions.missions'), subtitle: t('missions.missionInfoComponentTitleText', { year: new Date().getFullYear(), appTitle }), image: landingPageHeaderImage, imageAlt: t('missions.peopleOnMission') },
        React.createElement(Box, { sx: {
                columnGap: { xs: 2, lg: 3 },
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                rowGap: { xs: 2, sm: 0 },
            } },
            React.createElement(MissionPlaceholders, { missionsCount: missionsCount, volunteerHours: volunteerHours }))));
};
